import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import Store from "./redux/store";
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import appTheme from './theme/appTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <ThemeProvider theme={appTheme} >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider >
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
